module.exports = __webpack_public_path__ + "img/icon_comments.d7622de5.svg";